import { jsx } from 'react/jsx-runtime';
import { IconDesktop16KindEmail } from '@fabric-app/icons/svg';
import { cssVar } from '@fabric-app/ui/theme/variables';

const ResourcePreviewListItemEmail = () => {
  return /* @__PURE__ */ jsx(IconDesktop16KindEmail, {
    style: {
      color: cssVar["color-text-tertiary"]
    }
  });
};

export { ResourcePreviewListItemEmail };
//# sourceMappingURL=ResourcePreviewListItemEmail.js.map
